<div class="info-menu w-[300px]">
  @for (info of infoMenu; track info) {
    <a
      data-e2e="infoMenuElements"
      class="menu-item flex h-[68px] w-full cursor-pointer px-[15px]"
      [routerLink]="info.link"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: false }"
      (click)="routerLinkActivated.emit()"
    >
      <div class="flex h-full w-full items-center">
        <span class="text-base font-semibold">{{ info.label | translate }}</span>
      </div>
    </a>
  }
</div>
